import html2Canvas from 'html2canvas';
import NavBar from '@/components/Nav.vue';
import ShowCase from '@/components/ShowCase.vue';
import Redeem from '@/components/Redeem.vue';

import functions from '@/functions.js';
import enums from '@/configs/enums.js';
import client from '@/configs/client.js';

export default {
    name: 'EntityDetailPage',
    components: {
        ShowCase,
        NavBar,
        Redeem
    },
    data() {
        return {
            musics: [{}],
            player: false,
            musicRate: 0,
            musicIndex: 0,
            musicStart: 0,
            musicTotal: 0,
            musicQuality: 'hd',
            musicPlaying: false,
            musicQualityShow: false,
            hexToRgb: functions.hexToRgb,
            showDownload: client.xinhua || ! client.ios,
            shareShow: false,
            imageBase64: '',
            downloadShow: false,
            owner: false,
            entity: {product: {issuer: {}, organization: {}, tags: [], rgb: [0, 0, 0], color: ''}, nft: {}, user: {}},
            types: enums.productType,
            xinhua: client.xinhua,
            openEntity: this.$store.state.openEntity,
            showWelfareAlert: false,
            showWelfareInfo: false,
            welfares: [],
            welfareIndex: 0,
            plateRate: 0,
            transformTimer: null
        }
    },
    created() {
        this.$http.get('entity/' + this.$route.params.id).then(result => {
            this.owner = result.data.owner;
            result.data.entity.product.rgb = functions.hexToRgb(result.data.entity.product.color);
            result.data.entity.created_at = functions.dateFormat('YYYY-mm-dd HH:ii:ss', result.data.entity.created_at);
            this.musics = result.data.musics ? result.data.musics : [];
            this.entity = result.data.entity;
            this.welfares = result.data.welfares;
            this.showWelfareAlert = result.data.welfares.length;
            this.initShare({
                title: this.entity.product.share_title,
                description: this.entity.product.share_description,
                image: this.entity.product.share_image
            });
            if (this.openEntity && ! this.entity.is_open && this.entity.product.parent_id) {
                this.$http.post('entity/' + this.$route.params.id + '/open');
            }
        })
    },
    unmounted() {
        this.initShare();
        this.$store.state.openEntity = false;
        document.body.removeAttribute('class', 'van-overflow-hidden');
    },
    methods: {
        changeMusicQuality(value) {
            this.musicPlaying = false;
            this.musicQuality = value;
            this.musicQualityShow = false;
        },
        musicDownload() {
            let url = this.musics[this.musicIndex][this.musicQuality + '_mp4'];
            if (client.xinhua) {
                /* eslint-disable */
                let data = {url: url};
                if (client.ios) {
                    window.webkit.messageHandlers.downloadVideo.postMessage(data);
                } else {
                    xinhuanet.downloadVideo(JSON.stringify(data));
                }
                /* eslint-enable */
            } else {
                location.href = url;
            }
        },
        musicUpdate(event) {
            this.musicStart = Math.ceil(event.target.currentTime);
        },
        getTime(value) {
            let minute = Math.floor(value / 60);
            let second = value % 60;
            return minute + ':' + (second > 9 ? second : '0' + second);
        },
        initMusic(event) {
            this.musicTotal = Math.ceil(event.target.duration);
        },
        toggleMusicState() {
            if (this.musicPlaying) {
                if (this.musicStart == this.musicTotal) {
                    this.$refs.music.currentTime = 0;
                } else {
                    this.$refs.music.currentTime = this.musicRate / 100 * this.musicTotal;
                }
                this.$refs.music.play();
                this.transformTimer = setInterval(() => {
                    this.plateRate = this.plateRate + 5;
                }, 100);
            } else {
                this.$refs.music.pause();
                clearInterval(this.transformTimer);
            }
        },
        togglePlayer() {
            if (client.xinhua) {
                if (! functions.usableXinhuaVersion('8.8.50')) {
                    this.$toast('请升级客户端app后使用');
                } else {
                    let data = {
                        albumId: `${this.entity.product.id}`,
                        title: this.entity.product.name,
                        shareDesc: this.entity.product.share_description,
                        shareImg: this.entity.product.share_image,
                        shareUrl: location.href,
                        list: []
                    };
                    this.musics.forEach((music, index) => {
                        data.list.push({
                            id: `${this.entity.product.id}${index + 1}`,
                            name: music.name,
                            cover: music.cover,
                            url1: music.hd,
                            url2: music.perfect,
                            downloadUrl1: music.hd_mp4,
                            downloadUrl2: music.perfect_mp4,
                            playing: index ? false : true
                        });
                    })
                    if (client.ios) {
                        window.webkit.messageHandlers.goAudioAlbum.postMessage(data);
                    } else {
                        /* eslint-disable */
                        xinhuanet.goAudioAlbum(JSON.stringify(data));
                        /* eslint-enable */
                    }
                }
            } else {
                this.player = ! this.player;
                if (this.player) {
                    document.querySelector('body').className = 'van-overflow-hidden';
                } else {
                    document.body.removeAttribute('class', 'van-overflow-hidden');
                }
            }
        },
        changeMusic(value, sw = false) {
            let newValue = value;
            value = value == this.musics.length ? 0 : (value < 0 ? this.musics.length - 1 : value);
            if (this.musics.length && value != this.musicIndex) {
                let oldValue = this.musicIndex;
                this.musicIndex = value;
                this.musicStart = 0;
                this.musicQuality = 'hd';
                this.musicPlaying = false;
                this.plateRate = 0;
                if (sw) {
                    if (oldValue > newValue) {
                        this.$refs.swiper.prev();
                    } else {
                        this.$refs.swiper.next();
                    }
                }
            }
        },
        touchStart() {
            if (client.xinhua) {
                this.touch = setTimeout(() => {
                    let data = {imgbase64: this.imageBase64.substring(this.imageBase64.indexOf('base64,') + 7)};
                    if (client.ios) {
                        window.webkit.messageHandlers.DownloadImg.postMessage(data);
                    } else {
                        /* eslint-disable */
                        xinhuanet.DownloadImg(JSON.stringify(data));
                        /* eslint-enable */
                    }
                }, 1000)
            }
        },
        touchEnd() {
            if (client.xinhua) {
                clearTimeout(this.touch);
            }
        },
        download() {
            if (this.entity.product.id == 199) {
                location.href = 'https://my-h5news.app.xinhuanet.com/h5/nft/my_album_list.html?uuid=00c390aac7ab487ca33daa1e49fc3693';
            } else {
                this.$http.get('entity/' + this.$route.params.id + '/annex').then(result => {
                    if (client.xinhua) {
                        let video = result.data.annex.indexOf('mp4') > -1;
                        /* eslint-disable */
                        if (video) {
                            let data = {url: result.data.annex};
                            if (client.ios) {
                                window.webkit.messageHandlers.downloadVideo.postMessage(data);
                            } else {
                                xinhuanet.downloadVideo(JSON.stringify(data));
                            }
                        } else {
                            // 8.8.54版本，可以直接通过url下载图片
                            if (functions.usableXinhuaVersion('8.8.54')) {
                                window.xinhuanetApp.DownloadImgUrl({url: result.data.annex})
                            } else {
                                let image = new Image();
                                image.crossOrigin = '';
                                image.src = result.data.annex;
                                image.onload = () => {
                                    let data = {imgbase64: functions.getImageBase64(image)};
                                    if (client.ios) {
                                        window.webkit.messageHandlers.DownloadImg.postMessage(data);
                                    } else {
                                        xinhuanet.DownloadImg(JSON.stringify(data));
                                    }
                                }
                            }
                        }
                        /* eslint-enable */
                    } else {
                        location.href = result.data.annex;
                    }
                });
            }
        },
        downloadImage() {
            if (! this.imageBase64) {
                html2Canvas(document.querySelector('#preview'), {useCORS: true}).then(canvas => {
                    this.imageBase64 = canvas.toDataURL('image/png', 1.0);
                    this.downloadShow = true;
                })
            } else {
                this.downloadShow = true;
            }
        }
    },
    watch: {
        musicPlaying() {
            this.toggleMusicState();
        },
        musicStart(value) {
            this.musicRate = value / this.musicTotal * 100;
            if (this.musicRate >= 100) {
                this.musicPlaying = false;
            }
        },
    }
}